export default __webpack_public_path__ + "static/media/psactions_camerarawfilter.0eaf96c9.jpg";